import styled from 'styled-components';

export default styled.div`
  width: 350px;

  font-size: 18px;
`;
